export default "__VITE_PUBLIC_ASSET__42e6ec58__"